export default __webpack_public_path__ + "static/ella-de62c33492f682fb4a02b62261e5b624.jpg";